// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"fb6e899c","133":"0789f050","182":"12629d1a"}[chunkId] + ".chunk.js";
};